import ProductSimilar from "./ProductSimilar";

export default ProductSimilar;
